<template>
  <footer class="footer-component">
    <div class="footer-content">
      <p class="footer-line">
        <span class="footer-copyright">版权所有 © 国塔（广西）文化有限公司</span>
        <span class="sep">·</span>
        <span class="footer-tech">技术提供 杭州小缘文化科技有限公司</span>
        <span class="sep">·</span>
        <a class="footer-beian" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">桂ICP备2026021076号-1</a>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped>
/* 使用全局样式中定义的 CSS 变量 */
.footer-component {
  background-color: var(--bg-200);
  color: var(--text-200);
  padding: 12px 0;
  text-align: center;
  border-top: 1px solid var(--border);
  margin-top: auto;
  box-shadow: var(--shadow-sm);
}

.footer-content {
  max-width: 100%;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-line {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: var(--text-200);
}

.footer-line .sep {
  margin: 0 10px;
  color: var(--border, #c9bca9);
}

.footer-beian {
  color: var(--primary, #8E1103);
  text-decoration: none;
  transition: opacity .2s;
}

.footer-beian:hover {
  text-decoration: underline;
  opacity: .8;
}

/* 电脑端样式 */
@media (min-width: 769px) {
  .footer-component {
    width: 100%;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }
}

/* 手机端样式 */
@media (max-width: 768px) {
  .footer-component {
    width: 100%;
    position: relative;
    bottom: 0;
    left: 0;
  }
  .footer-line {
    font-size: 11px;
  }
  .footer-line .sep {
    margin: 0 6px;
  }
}
</style>
